import React from "react";
import styled, { keyframes } from "styled-components";
import loaderVideo from "../../../assets/images/marketplace/marketplace_loader.mp4";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

interface MarketplaceLoaderProps {
  fullPage?: boolean;
  fullScreen?: boolean;
  message?: string;
  size?: number;
}

const FullScreenOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  background: #0a0a0a;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.2s ease-out forwards;
`;

const FullScreenVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
`;

const LoaderContainer = styled.div<{ $fullPage?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.3s ease-out forwards;
  
  ${({ $fullPage }) =>
    $fullPage
      ? `
        width: 100%;
        min-height: 60vh;
        display: flex;
        flex: 1;
      `
      : `
        padding: 40px;
        width: 100%;
      `}
`;

const VideoWrapper = styled.div<{ $size: number }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.05);
`;

const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const LoadingText = styled.p`
  margin-top: 20px;
  font-size: 15px;
  font-weight: 500;
  color: var(--mp-subColor, #888);
  letter-spacing: 0.5px;
  animation: ${fadeIn} 0.5s ease-out;
`;

const MarketplaceLoader: React.FC<MarketplaceLoaderProps> = ({
  fullPage = true,
  fullScreen = false,
  message,
  size = 140,
}) => {
  if (fullScreen) {
    return (
      <FullScreenOverlay>
        <FullScreenVideo
          src={loaderVideo}
          autoPlay
          loop
          muted
          playsInline
        />
      </FullScreenOverlay>
    );
  }

  return (
    <LoaderContainer $fullPage={fullPage}>
      <VideoWrapper $size={size}>
        <StyledVideo
          src={loaderVideo}
          autoPlay
          loop
          muted
          playsInline
        />
      </VideoWrapper>
      {message && <LoadingText>{message}</LoadingText>}
    </LoaderContainer>
  );
};

export default MarketplaceLoader;
